<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P0twDr/tc-custom/9781611528664.jpg?1723406431981" alt="This image is the cover for the book Djinn Book 2: Where There's Smoke, Djinn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Djinn Book 2: Where There's Smoke, Djinn
      </h1>
      <p class="bookDescription body article font2">
        <p>After Dale Edinger’s eccentric aunt passed away, she left him with a house full of clutter mixed with magical items and a djinn named Riadh. With his own history and a set of rules that make it impossible for him to be freed, Riadh now belongs to Dale. But when your skills at magic are one step above non-existent, you need a teacher.<br/><br/>Now Dale’s on the hunt for a teacher so he’ll not only learn how to wield magic, but will also be able to protect Riadh. Unfortunately, his options are limited. Who poses the greater risk -- a dragon with uncertain motives, or a big city mage who'd like to add Riadh to his own collection of possessions?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.R. Moler
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f4f787b